import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import {
  fetchClearDetailNotification,
  fetchNotificationList,
} from "../actions/notification";
import {
  statusNotificationRender,
  typeNotificationRender,
} from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchDeleteNotification } from "../actions/notification";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const NotificationList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "notifications";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { notificationList } = useSelector(
    (state) => state.notificationReducer
  );

  useEffect(() => {
    dispatch(fetchNotificationList());
    dispatch(fetchClearDetailNotification());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/notification-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteNotification(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("notificationList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 200,
    },
    {
      headerName: t("notificationList.title"),
      field: "title",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("notificationList.type"),
      field: "type",
      cellRenderer: typeNotificationRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.type) return null;
        switch (params.data.type) {
          case "APP":
            return t("notificationList.typeApp");
          case "MAIL":
            return t("notificationList.typeMail");
          case "BOTH":
            return t("notificationList.typeBoth");
          default:
            return "";
        }
      },
      filter: "agSetColumnFilter",
      width: 200,
    },
    {
      headerName: t("notificationList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      width: 200,
      cellRenderer: statusNotificationRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "PREPARED":
            return t("notificationList.statusPrepared");
          case "FINISHED":
            return t("notificationList.statusFinished");
          case "IN_PROGRESS":
            return t("notificationList.statusInProgress");
          default:
            return "";
        }
      },
    },
    {
      headerName: t("notificationList.deliveryTime"),
      field: "deliveryTime",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 110,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={notificationList}
        columnDefs={columnDefs}
        buttonLink={`/notification-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"notification-list"}
      />
    </Fragment>
  );
};

export default NotificationList;
